export class CheckCdcPrerequisitesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ramShareCheck",
            "baseName": "ramShareCheck",
            "type": "RamShareCheckResult",
            "format": ""
        },
        {
            "name": "parameterChecks",
            "baseName": "parameterChecks",
            "type": "Array<ParameterCheckResult>",
            "format": ""
        },
        {
            "name": "privateLinkCheck",
            "baseName": "privateLinkCheck",
            "type": "PrivateLinkCheckResult",
            "format": ""
        },
        {
            "name": "cdcBackupModeCheck",
            "baseName": "cdcBackupModeCheck",
            "type": "CdcBackupModeCheckResult",
            "format": ""
        },
        {
            "name": "sourceSizeCheck",
            "baseName": "sourceSizeCheck",
            "type": "SourceSizeCheckResult",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckCdcPrerequisitesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
